export const linkViewMessages = {
  linkView: 'Link view',
  linkTableView: 'Table view',
  linkCardView: 'Card view',
  linkCardAria: 'Link /{slug}',
} as const;
